if (!customElements.get('video-background')) {
  class VideoBackground extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.videoWrapper = this.querySelector('.video-bg-vdo-wrapper');
      this.tickerList = this.querySelector('.video-bg-ticker-list');
      this.revealElements = this.querySelectorAll('.reveal');

      // Settings
      this.runwayMultiplier = (parseFloat(this.dataset.runway) || 200) / 100;
      this.tickerDistance = parseFloat(this.dataset.tickerDistance) || 400;
      this.isRTL = document.documentElement.getAttribute('dir') === 'rtl';
      this.isComplete = false;
      this.ticking = false;

      // Set runway height (this creates the scroll distance)
      this.style.height = `${this.runwayMultiplier * 100}vh`;

      // Trigger reveal animations on first visibility
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.revealElements.forEach((el, i) => {
              setTimeout(() => el.setAttribute('data-revealed', 'true'), i * 150);
            });
            revealObserver.disconnect();
          }
        });
      }, { threshold: 0.1 });
      revealObserver.observe(this);

      // Video playback control
      if (this.video) {
        const playObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) this.video.play().catch(() => {});
            else this.video.pause();
          });
        }, { threshold: 0.1 });
        playObserver.observe(this);
      }

      // Scroll-linked animation
      this.onScroll = () => {
        if (this.ticking) return;
        requestAnimationFrame(() => {
          this.updateScrollProgress();
          this.ticking = false;
        });
        this.ticking = true;
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.updateScrollProgress();
    }

    updateScrollProgress() {
      const rect = this.getBoundingClientRect();
      const scrollRange = this.offsetHeight - window.innerHeight;
      if (scrollRange <= 0) return;

      const scrolled = Math.max(0, -rect.top);
      const progress = Math.min(1, Math.max(0, scrolled / scrollRange));

      // PHASE 1: Video animation completes by 50% of scroll
      const videoProgress = Math.min(1, progress / 0.5);
      const eased = this.easeOutCubic(videoProgress);

      const ty = 200 * (1 - eased);
      const rot = -6 * (1 - eased);
      const scl = 0.8 + 0.2 * eased;

      if (this.videoWrapper) {
        this.videoWrapper.style.transform = `translateY(${ty}px) rotate(${rot}deg) scale(${scl})`;
      }

      // Add is-complete when video animation finishes
      if (videoProgress >= 1 && !this.isComplete) {
        this.classList.add('is-complete');
        this.isComplete = true;
      } else if (videoProgress < 1 && this.isComplete) {
        this.classList.remove('is-complete');
        this.isComplete = false;
      }

      // PHASE 2: Ticker moves throughout full scroll
      if (this.tickerList) {
        const direction = this.isRTL ? 1 : -1;
        const tx = progress * this.tickerDistance * direction;
        this.tickerList.style.transform = `translateX(${tx}px)`;
      }
    }

    easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }

  customElements.define('video-background', VideoBackground);
}